import { Link } from 'react-router-dom'
import type { Pattern } from '../../content/system'
import Icon from './Icon'
export function PatternThumbnail({ id }: { id: string }) {
  return (
    <div className={`pat-thumb pat-thumb--${id}`} aria-hidden="true">
      <div className="pat-mini">
        <div className="pat-mini__header">
          <span />
          <i />
          <i />
        </div>
        {id === 'mission-dashboard' ? (
          <>
            <div className="pat-mini__metrics">
              <b>
                24<small>Active</small>
              </b>
              <b>
                18<small>Complete</small>
              </b>
              <b>
                6<small>In review</small>
              </b>
            </div>
            <div className="pat-mini__chart">
              <i />
              <i />
              <i />
              <i />
              <i />
              <i />
              <i />
            </div>
          </>
        ) : id === 'review-queue' ? (
          <>
            <div className="pat-mini__filter" />
            <div className="pat-mini__row">
              <span />
              <b>Ready</b>
            </div>
            <div className="pat-mini__row">
              <span />
              <b>In review</b>
            </div>
            <div className="pat-mini__row">
              <span />
              <b>Ready</b>
            </div>
          </>
        ) : id === 'guided-intake' ? (
          <>
            <div className="pat-mini__steps">
              <i>1</i>
              <span />
              <i>2</i>
              <span />
              <i>3</i>
            </div>
            <div className="pat-mini__input" />
            <div className="pat-mini__input pat-mini--short" />
            <div className="pat-mini__button" />
          </>
        ) : id === 'record-detail' ? (
          <>
            <div className="pat-mini__text pat-mini--bold" />
            <div className="pat-mini__detail">
              <span>Owner</span>
              <i />
            </div>
            <div className="pat-mini__detail">
              <span>Status</span>
              <b>In review</b>
            </div>
            <div className="pat-mini__text" />
            <div className="pat-mini__text pat-mini--short" />
          </>
        ) : id === 'cited-answer' ? (
          <>
            <div className="pat-mini__answer">
              <Icon name="spark" size={14} />
              <div>
                <div className="pat-mini__text" />
                <div className="pat-mini__text" />
                <div className="pat-mini__text pat-mini--short" />
              </div>
            </div>
            <div className="pat-mini__source">
              <Icon name="file" size={13} /> Source evidence <span>↗</span>
            </div>
          </>
        ) : (
          <div className="pat-mini__empty">
            <Icon name="search" size={23} />
            <strong>No matches found</strong>
            <div className="pat-mini__text pat-mini--short" />
            <div className="pat-mini__button" />
          </div>
        )}
      </div>
    </div>
  )
}
export default function PatternCard({ pattern }: { pattern: Pattern }) {
  return (
    <Link to={`/patterns/${pattern.id}`} className="pat-card">
      <PatternThumbnail id={pattern.id} />
      <span className="pat-card__body">
        <span className="mds-eyebrow">{pattern.category}</span>
        <span className="pat-card__title">
          {pattern.title}
          <Icon name="arrow" size={18} />
        </span>
        <span className="pat-card__summary">{pattern.summary}</span>
      </span>
    </Link>
  )
}
